<template>
  <div class="customerForm">
    <el-card class="box-card">
      <h2> {{header}} </h2>
      <el-form ref="customerForm" label-position="left" :model="customerForm" :rules="genRules" label-width="150px"
               style="margin-left: 15%; margin-right: 15%; text-align:left">
        <el-form-item label="Customer Name" prop="name">
          <el-input v-model="customerForm.name"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="customerForm.email"></el-input>
        </el-form-item>
        <el-form-item label="Address" prop="addr">
          <el-input v-model="customerForm.addr"></el-input>
        </el-form-item>
        <el-form-item label="Tel." prop="tel">
          <el-input v-model="customerForm.tel"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="desc">
          <el-input v-model="customerForm.desc"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center">
          <el-button type="success" plain @click="onSubmit()" :loading="generating">Submit</el-button>
          <el-button type="info" plain @click="$router.go(-1)">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {addCustomer, modifyCustomer} from '../api'
import moment from 'moment'
export default {
  name: 'CustomerForm',
  data () {
    return {
      generating: false,
      action: 'Undefined',
      header: '',
      customerForm: {
        cus_id: '',
        name: '',
        email: '',
        addr: '',
        tel: '',
        desc: ''
      },
      genRules: {
        name: [
          { required: true, message: 'Please Enter Customer Name', trigger: 'blur' }
        ],
        email: [
          { type: 'email', required: true, message: 'Please Enter a Valid Email Address', trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount: function () {
    this.generating = false
  },
  created: function () {
    this.action = this.$route.params.action ? this.$route.params.action : 'add'
    this.header = this.action === 'add' ? 'Add Customer' : 'Modify Customer'
    if (this.action === 'modify') {
      this.customerForm.cus_id = this.$route.params.data ? this.$route.params.data.cus_id : ''
      this.customerForm.name = this.$route.params.data ? this.$route.params.data.name : ''
      this.customerForm.email = this.$route.params.data ? this.$route.params.data.email : ''
      this.customerForm.addr = this.$route.params.data ? this.$route.params.data.addr : ''
      this.customerForm.tel = this.$route.params.data ? this.$route.params.data.tel : ''
      this.customerForm.desc = this.$route.params.data ? this.$route.params.data.desc : ''
    }
  },
  methods: {
    onSubmit () {
      const that = this
      console.log('that.action = %s', that.action)
      that.$refs.customerForm.validate((valid) => {
        if (valid) {
          that.generating = true
          if (that.action === 'add') {
            addCustomer(that.customerForm).then(data => {
              that.generating = false
              console.log('addCustomer Success -> data')
              console.log(data)
              that.$router.push({name: 'CustomerList'})
            }).catch(error => {
              if (error.response) {
                if (error.response.status === 400) {
                  that.$notify.error({
                    title: 'Error',
                    message: error.response.data
                  })
                } else if (error) {
                  console.log(error.stack)
                }
              }
              that.generating = false
            })
          } else if (that.action === 'modify') {
            modifyCustomer(that.customerForm).then(data => {
              that.generating = false
              console.log('modifyCustomer Success -> data')
              console.log(data)
              that.$router.push({name: 'CustomerList'})
            }).catch(error => {
              if (error) {
                console.log(error.stack)
              }
              that.generating = false
            })
          }
        }
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss ZZ', true)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .generate{
    margin: 0px auto;
    position: relative;
    margin-top: 50px;
  }
  .changed {
    background-color: orange;
    color: white;
  }
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// CustomerForm.vue?c4d549fa